<template>
  <div class="sdv-chart">
    <div ref="el" class="el" />
    <div v-if="badData" class="overlay"><div class="text">{{ $t('no_data_for_these_filters') }}</div></div>
  </div>
</template>

<script>
import $ from 'jquery'
import chartUtils from '@/utils/chart'
import { maskValue } from '@/utils/formatUtils'
import * as sdv from '@/lib/sdv-lib'
export default {
  components: { },
  props: {
    chartConfig: {
      type: Object,
    },
    data: {},
    chartType: {
      type: String,
    },
    tooltipFunction: {
      type: Function,
    },
    lite: {
      type: Boolean
    }
  },
  computed: {
    sdvComponent() {
      let tmp = chartUtils[this.chartType].sdvComponent
      return tmp
    },
    badData() {
      // PARA cuando hay algo como "españa" pero no tiene ningun dato...
      if (this.chartData.length === 1) return true
      if (chartUtils[this.chartType].checkBadData) {
        return chartUtils[this.chartType].checkBadData(this.chartData)
      }
      else return false
    },
    chartData() {
      return this.data || []
    },
    hasExternalLegend() {
      return this.chartType === 'heat-map' && this.chartConfig?.LegendBehavior?.showLegend.value
    },
  },
  watch: {
    sdvComponent: {
      handler() {
        this.instantiateChart()
      },
      // immediate: true,
    },
    chartData: {
      handler(value) {
        // Para justo cuando se instancia...
        if (
          this.instance &&
          this.sdvComponent === this.instance.constructor.name.replace('Component', '')
        ) {
          this.setChartData(value)
        }
      },
    },
    chartConfig: {
      handler(value) {
        let newConfig = value
        if (this.instance && newConfig) this.instance.config = newConfig
        this.instance.new = false
      },
      deep: true,
    },
  },
  mounted() {
    this.instantiateChart()
  },
  updated() {
    this.instantiateChart()
  },
  methods: {
    setChartData(value) {
      if (!this.badData && this.instance) {
        this.instance.viz.chart.__allTimeValues = this.allTimeValues
        this.instance.data = { data: value }
      }
    },
    instantiateChart() {
      if (!this.sdvComponent) return
      let $el = this.$refs.el
      $($el).empty()
      let component = sdv[this.sdvComponent]
      //CUSTOM CONFIGS,
      let customConfig
      try {
        customConfig = JSON.parse(
          JSON.stringify(sdv.configUtils.extractValues(this.chartConfig || {}))
        )
      } catch {
        customConfig = JSON.parse(JSON.stringify(this.chartConfig || {}))
      }
      if (!customConfig.title) customConfig.title = { value: '' }
      customConfig.valueFormat = value => maskValue(value, { mask: '0,0'})

      // los "injected" lo necesitan ANTES del instantiate pero los "PivotComponent" despues....
      if (this.tooltipFunction)
        customConfig.TooltipBehavior = { getHtml: { value: this.tooltipFunction } }
      let instance = new component($el, null, customConfig)
      // let instance = new component($el, { data: this.chartData }, {})
      instance.onReady = () => {
        this.instance = instance
        console.log('chart was drawn and can be modified')
        if (this.chartData) {
          this.setChartData(this.chartData)
        }

        let defaults = this.instance._getConfig()
        let values = this.instance.viz.chart._config
        let nonDefaults = sdv.configUtils.filterNonDefaults(values, defaults)

        let merged = sdv.configUtils.mergeConfig(nonDefaults, defaults)
        merged = sdv.configUtils.setDefaultValues(merged)
        // los "injected" lo necesitan ANTES del instantiate pero los "PivotComponent" despues....
        if (this.tooltipFunction) merged.TooltipBehavior.getHtml.value = this.tooltipFunction
        console.log('DEFAULT CONFIG', merged)
        // merged.ItemsHelper.colorScale.value = 'single'
        instance.new = true
        this.$emit('change-chart-config', merged)
      }
    },
    getNonDefaultConfig() {
      let defaults = this.instance._getConfig()
      let values = this.instance.viz.chart._config
      let nonDefaults = sdv.configUtils.filterNonDefaults(values, defaults)
      return nonDefaults
    },
    // fillIds(data) {
    //   if (this.sdvComponent === 'BarChart') {
    //     data = [
    //       ...this.allIds.map(idOb => {
    //         return data.find(d => d[0].value === idOb.id) || [idOb.label, 0]
    //       }),
    //     ]
    //   }
    //   return data
    // },
  },
}
</script>

<style lang="stylus" scoped>
.sdv-chart
  height: 100%

  // border: solid 2px #f90
  .el
    width: 100%
    height: 100%
    border: none !important

  .overlay
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: rgba(255, 255, 255, 0.8)

    .text
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)

  .map-legend
    position: absolute
    top: vw(0)
    left: vw(40)
    z-index: 2
</style>
